import React from 'react';
import { useMainCategoryList } from '../MainCategorySelect/useMainCategoryList';

interface MainCategoryNameProps {
  mainCategoryId: number;
}

const MainCategoryName = (props: MainCategoryNameProps): JSX.Element => {
  const { mainCategoryId } = props;

  const mainCategoryList = useMainCategoryList();
  const name = mainCategoryList.find((item) => item.id === mainCategoryId)?.name;

  return name ? <span>{name}</span> : <></>;
};

export default MainCategoryName;
